import React, { useEffect, useState, useRef } from "react";
import httpClient from "../../utils/httpClient";

function Header() {
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [noti, setNoti] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const notificationRef = useRef(null);
  const [profilePic, setProfilePic] = useState(() => {
    // Initialize from localStorage if available
    const storedPic = localStorage.getItem("ProviderProfilePic");
    return storedPic && storedPic !== ""
      ? storedPic
      : "/assets/img/profiles/avatar-02.jpg";
  });

  const fetchProfilePic = () => {
    httpClient
      .get("auth/get-profile")
      .then((res) => {
        if (res.data?.data?.profilePic && res.data.data.profilePic !== "") {
          const newProfilePic = res.data.data.profilePic;
          setProfilePic(newProfilePic);
          // Update localStorage
          localStorage.setItem("ProviderProfilePic", newProfilePic);
        }
      })
      .catch((err) => {
        console.log("Error fetching profile picture:", err);
      });
  };

  useEffect(() => {
    // Fetch profile picture on mount
    fetchProfilePic();

    // Listen for profile update events
    const handleProfileUpdate = () => {
      fetchProfilePic();
    };

    window.addEventListener("profileUpdated", handleProfileUpdate);

    return () => {
      window.removeEventListener("profileUpdated", handleProfileUpdate);
    };
  }, []);

  const handleUpdateNotiStatus = async () => {
    setOpenNotification(!openNotification);
    try {
      const res = await httpClient.patch("/notification/update-notification");
      console.log("res", res.data);
      if (res.data.success) {
        setNotificationCount(0);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const fetchNoti = () => {
      setIsLoading(true);
      httpClient
        .get("notification/get-notification")
        .then((res) => {
          setNoti(res.data?.data.notifications);
          setNotificationCount(res.data?.data?.unreadCount);
        })
        .catch((err) => {
          setNoti([]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    fetchNoti();
  }, []);

  // Close notification dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target) &&
        openNotification
      ) {
        setOpenNotification(false);
      }
    };

    if (openNotification) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openNotification]);
  return (
    <>
      <>
        {/* Header */}
        <div className="header provider-header ">
          {/* Logo */}
          <div className="header-left active">
            <a className="logo logo-normal">
              <img src="/assets/img/logo-web.png" alt="Logo" />
            </a>
            <a className="logo-small">
              <img src="/assets/img/favicon.png" alt="Logo" />
            </a>
            {/* <a id="toggle_btn" href="javascript:void(0);">
              <i className="ti ti-menu-deep" />
            </a> */}
          </div>
          {/* /Logo */}
          <a
            id="mobile_btn"
            className="mobile_btn"
            href="#sidebar"
            onClick={(e) => {
              e.preventDefault();
              // Only toggle on mobile
              if (window.innerWidth <= 991.98) {
                const sidebar = document.getElementById("sidebar");
                const overlay = document.getElementById("sidebar-overlay");
                if (sidebar) {
                  const currentMargin =
                    sidebar.style.marginLeft ||
                    window.getComputedStyle(sidebar).marginLeft;
                  if (currentMargin === "0px" || currentMargin === "0") {
                    sidebar.style.marginLeft = "-575px";
                    setSidebarOpen(false);
                    if (overlay) {
                      overlay.style.display = "none";
                    }
                  } else {
                    sidebar.style.marginLeft = "0";
                    setSidebarOpen(true);
                    if (overlay) {
                      overlay.style.display = "block";
                    }
                  }
                }
              }
            }}
          >
            <span className="bar-icon">
              <span />
              <span />
              <span />
            </span>
          </a>
          <div className="header-user">
            <div className="nav user-menu">
              {/* Search */}
              {/* <div className="nav-item nav-search-inputs">
                <div className="top-nav-search">
                  <a href="javascript:void(0);" className="responsive-search">
                    <i className="fa fa-search" />
                  </a>
                  <form action="#" className="dropdown">
                    <div className="searchinputs" id="dropdownMenuClickable">
                      <input type="text" placeholder="Search" />
                      <div className="search-addon">
                        <span>
                          <i className="feather-user" />
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div> */}
              {/* /Search */}
              <div className="d-flex align-items-center">
                {/* <div className="me-2 site-link">
                  <a
                    href="index.html"
                    className="d-flex align-items-center justify-content-center me-2"
                  >
                    <i className="feather-globe me-1" />
                    Visit Website
                  </a>
                </div> */}
                <div className="me-2 site-link">
                  <a
                    // href="index.html"
                    className="d-flex align-items-center justify-content-center me-2"
                  >
                    {localStorage.getItem("ProviderName")}
                  </a>
                </div>
                <div
                  className="provider-head-links"
                  style={{ position: "relative" }}
                  ref={notificationRef}
                >
                  <a
                    // href="javascript:void(0);"
                    className="d-flex align-items-center justify-content-center me-2 dropdown-toggle notify-link position-relative"
                    // data-bs-toggle="dropdown"
                    // data-bs-auto-close="outside"
                    // aria-expanded="true"
                    onClick={() => handleUpdateNotiStatus()}
                  >
                    <i className="feather-bell" />
                    {notificationCount > 0 && (
                      <span className="notification-badge">
                        {notificationCount > 99 ? "99+" : notificationCount}
                      </span>
                    )}
                  </a>
                  {openNotification && (
                    <>
                      <div className="notification-dropdown">
                        {/* <div
                        className="dropdown-menu dropdown-menu-end notification-dropdown p-3"
                        style={{ border: "2px solid red" }}
                      > */}
                        <div className="d-flex dropdown-body align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
                          <h6 className="notification-title">
                            Notifications{" "}
                            {/* <span className="fs-16 text-gray"> (2)</span> */}
                          </h6>
                          {/* <div className="d-flex align-items-center">
                            <a
                              href="#"
                              className="text-primary fs-15 me-3 lh-1"
                            >
                              Mark all as read
                            </a>
                            <div className="dropdown">
                              <a
                                // href="javascript:void(0);"
                                className="bg-white dropdown-toggle"
                                // data-bs-toggle="dropdown"
                                // data-bs-auto-close="outside"
                              >
                                <i className="ti ti-calendar-due me-1" />
                                Today
                              </a>
                              <ul className="dropdown-menu mt-2 p-3">
                                <li>
                                  <a
                                    href="javascript:void(0);"
                                    className="dropdown-item rounded-1"
                                  >
                                    This Week
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="javascript:void(0);"
                                    className="dropdown-item rounded-1"
                                  >
                                    Last Week
                                  </a>
                                </li>
                                <li>
                                  <a
                                    // href="javascript:void(0);"
                                    className="dropdown-item rounded-1"
                                  >
                                    Last Week
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div> */}
                        </div>
                        <div className="noti-content">
                          <div className="d-flex flex-column">
                            {noti.length > 0 ? (
                              noti.map((item) => (
                                <>
                                  <div className="border-bottom mb-3 pb-3">
                                    <a>
                                      <div className="d-flex">
                                        <span className="avatar avatar-lg me-2 flex-shrink-0">
                                          <img
                                            src={
                                              item?.serviceImg &&
                                              item?.serviceImg !== ""
                                                ? item?.serviceImg
                                                : "/assets/img/broken-image1.png"
                                            }
                                            alt="Service Image"
                                            className="rounded-circle"
                                          />
                                        </span>
                                        <div className="flex-grow-1">
                                          <div className="d-flex align-items-center">
                                            <p className="mb-1 w-100">
                                              <span className="text-dark fw-semibold">
                                                {item.title}
                                              </span>{" "}
                                            </p>
                                          </div>
                                          <p>{item.message}</p>

                                          <span>
                                            {item.createdAt?.substring(0, 10)}
                                          </span>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </>
                              ))
                            ) : (
                              <div className="border-bottom mb-3 pb-3">
                                <a>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div className="d-flex align-items-center">
                                        <p className="mb-1 w-100">
                                          No Notifications Yet!
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="d-flex p-0 notification-footer-btn">
                          <a href="#" className="btn btn-light rounded  me-2">
                            Cancel
                          </a>
                          <a href="#" className="btn btn-dark rounded ">
                            View All
                          </a>
                        </div> */}
                      </div>
                    </>
                  )}
                </div>

                <div className="dropdown1">
                  <a data-bs-toggle="dropdown">
                    <div className="booking-user d-flex align-items-center">
                      <span className="user-img">
                        <img
                          src={profilePic}
                          alt="user"
                          onError={(e) => {
                            e.target.src = "/assets/img/profiles/avatar-02.jpg";
                          }}
                        />
                      </span>
                    </div>
                  </a>
                  <ul className="dropdown-menu p-2">
                    <li>
                      <a
                        className="dropdown-item d-flex align-items-center"
                        // href="login.html"
                      >
                        <i className="ti ti-logout me-1" />
                        Logout
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* Mobile Menu */}
          {/* <div class="dropdown mobile-user-menu">
          <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
              aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
          <div class="dropdown-menu dropdown-menu-end">
              <a class="dropdown-item" href="profile.html">My Profile</a>
              <a class="dropdown-item" href="profile-settings.html">Settings</a>
              <a class="dropdown-item" href="login.html">Logout</a>
          </div>
      </div> */}
          {/* /Mobile Menu */}
        </div>
        {/* /Header */}
      </>
    </>
  );
}

export default Header;
